<template>
  <div id="comp-profile">
    {{ userInitial }}
    <a class="btn-edit" :class="editBtn" @click="fileOpen">
      <i class="fas fa-pencil-alt"></i>
    </a>
    <a class="badge" :class="badgeBtn">{{ badge }}</a>
    <a class="owner" :class="badgeBtn"><i class="fas fa-crown"></i></a>
    <input
      type="file"
      id="profileImage"
      style="display:none;"
      @change="filesChange($event.target.files)"
      accept="image/*"
    />
    <div
      class="profile-inner"
      :style="{ backgroundImage: `url(${profileImage})` }"
    ></div>
    <div class="me" v-if="isMe" />
  </div>
</template>

<script>
export default {
  name: 'comp-profile',
  props: {
    userInitial: String,
    editBtn: String,
    profileImage: String,
    badgeBtn: String,
    badge: Number,
    isMe: Boolean,
  },
  methods: {
    fileOpen() {
      this.$el.querySelector('#profileImage').click();
    },
    filesChange(files) {
      const profile = this.$el.querySelector('.profile-inner');
      const reader = new FileReader();

      if (files[0]) {
        reader.readAsDataURL(files[0]);
        this.$emit('changeImage', files[0]);
      }

      reader.onloadend = () => {
        profile.style.backgroundImage = `url(${reader.result})`;
      };
    },
  },
};
</script>

<style lang="scss" src="../scss/comp-profile.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/CompProfile.vue